<!--  

COMPONENTE PARA INFORMAR DESTINATARIOS PARA ENVIO DE EMAIL

-->


<script>

import { SysVars } from '../main';

export default {

    props: {
      destinatarios: Object,
      url: String,
    },

    data () {
        return {

            showCC: false,
            showBCC: false,

            toList: [],
            ccList: [],
            bccList: [],

        }
    },

    computed: {
        getDestinatarios: function () {
            let destinatarios = {}

            if (this.$refs.to.isValid)
              destinatarios.toList = this.$refs.to.emailList 

            if (this.$refs.cc.isValid)
              destinatarios.ccList = this.$refs.cc.emailList 

            if (this.$refs.bcc.isValid)
              destinatarios.bccList = this.$refs.bcc.emailList 
            
            return destinatarios
        }

    },

    watch: {
        destinatarios: function () {
            this.toList = this.destinatarios.toList
            this.ccList = this.destinatarios.ccList
            this.bccList = this.destinatarios.bccList
        }
    },

    filters: {

    },

    methods: {
        isValid () {
            if (!this.$refs.to.isValid) {
                this.$erpToastError('Endereço de e-mail inválido')
                this.$refs.to.focus()
                return false
            }

            if (!this.$refs.cc.isValid) {
                this.$erpToastError('Endereço de e-mail inválido')
                this.$refs.cc.focus()
                return false
            }

            if (!this.$refs.bcc.isValid) {
                this.$erpToastError('Endereço de e-mail inválido')
                this.$refs.bcc.focus()
                return false
            }

            return true
        },

        focus () {
              this.$refs.to.focus()
        },

        handleBlurCC () {
            if (this.$refs.cc.emailList.length == 0)
              this.showCC = false
        },

        handleBlurBCC () {
            console.log(this.$refs.bcc.emailList.length)
            if (this.$refs.bcc.emailList.length == 0)
              this.showBCC = false
        },

    },

    created () {
        if (this.destinatarios) {
            this.toList = this.destinatarios.toList
            this.ccList = this.destinatarios.ccList
            this.bccList = this.destinatarios.bccList
        }
    }

}

</script>

<template>
    <div class="row align-items-center">
        <div class="col-12">
            <v-label label="Para"></v-label>
            <input-email-list ref="to" :url="url" :emails="toList"></input-email-list>
        </div>
        <div v-show="showCC" class="col-12 mt-2">
            <v-label label="CC"></v-label>
            <input-email-list ref="cc" :url="url" :emails="ccList" @blur="handleBlurCC"></input-email-list>
        </div>
        <div v-show="showBCC" class="col-12 mt-2">
            <v-label label="CCo"></v-label>
            <input-email-list ref="bcc" :url="url" :emails="bccList" @blur="handleBlurBCC"></input-email-list>
        </div>
        <div class="col-12 mt-2">
                <span class="lbl-edit" v-if="!showCC" @click="showCC = true" style="cursor: pointer">CC</span>
                <span class="lbl-edit" v-if="!showBCC" @click="showBCC = true" style="cursor: pointer">CCo</span>
        </div>
    </div>
    
</template>


<style scoped>


</style>



// WEBPACK FOOTER //
// src/forms-crm/crm-email-destinatarios.vue